import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";

/**
 * Hook for sending temporary password to users
 */
export const useSendTemporaryPassword = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Send temporary password mutation
  // @ts-ignore - Type checking for trpc.user property
  const sendTemporaryPasswordMutation =
    trpc.user.sendTemporaryPassword.useMutation({
      onSuccess: () => {
        // Invalidate the users queries to refresh data
        // @ts-ignore - Type checking for utils.user property
        utils.user.getUsers.invalidate();
        // @ts-ignore - Type checking for utils.user property
        utils.user.getUserById.invalidate();
      },
    });

  // Function to send temporary password with better error handling
  const sendTemporaryPassword = useCallback(
    async (userId: string) => {
      try {
        await sendTemporaryPasswordMutation.mutateAsync({ userId });
        return { success: true };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to send temporary password",
        };
      }
    },
    [sendTemporaryPasswordMutation]
  );

  return {
    sendTemporaryPassword,
    isLoading: sendTemporaryPasswordMutation.isLoading,
    isError: sendTemporaryPasswordMutation.isError,
    error: sendTemporaryPasswordMutation.error,
    isSuccess: sendTemporaryPasswordMutation.isSuccess,
    reset: sendTemporaryPasswordMutation.reset,
  };
};